import {MenuItem, Typography} from '@mui/material';
import {AppDialog} from 'components/dialogs';
import {AppTabs, TabsType} from 'components/tabs';
import {Setting2} from 'iconsax-react';
import {TenantSettingsUniqueIdKeysEnum} from 'models/settings';
import {useMemo, useState} from 'react';
import {TenantMemberSetting} from './components';

export const TenantSetting = () => {
    const [openTenantSettingDialog, setOpenTenantSettingDialog] = useState(false);
    const handleToggleTenantSettingDialog = () => {
        setOpenTenantSettingDialog(!openTenantSettingDialog);
    };

    const tabs: TabsType<string>[] = useMemo(() => {
        const response: TabsType<string>[] = [
            {
                title: 'Members',
                key: TenantSettingsUniqueIdKeysEnum.Members.toString(),
                component: <TenantMemberSetting />,
            },
        ];

        return response;
    }, []);
    return (
        <>
            <MenuItem
                sx={{px: 1, display: 'flex', justifyContent: 'space-between'}}
                onClick={event => {
                    event.stopPropagation();
                    handleToggleTenantSettingDialog();
                }}
            >
                <Typography>Tenant Settings</Typography>
                <Setting2 size={'18px'} />
            </MenuItem>
            {openTenantSettingDialog && (
                <AppDialog
                    open={openTenantSettingDialog}
                    onCloseDialog={handleToggleTenantSettingDialog}
                    title="Tenant Settings"
                    children={
                        <AppTabs tabs={tabs} selectedTabValue={TenantSettingsUniqueIdKeysEnum.Members.toString()} />
                    }
                    fullWidth
                    maxWidth="lg"
                />
            )}
        </>
    );
};

export default TenantSetting;
